import { useCallback, useEffect, useState } from 'react'
import { orderRepository } from '../../data/repositories/OrderRepositoryImpl'
import { OrderDetail } from '../../domain/entities/Order'

export const useOrderDetail = (orderId: string | null) => {
  const [detail, setDetail] = useState<OrderDetail | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchDetail = useCallback(async () => {
    if (!orderId) {
      setDetail(null)
      return
    }

    setLoading(true)
    setError(null)
    try {
      const res = await orderRepository.getOrderDetail(orderId)
      setDetail(res)
    } catch (err: unknown) {
      const errorVal = err as Error
      setError(errorVal.message || 'Failed to load order detail.')
    } finally {
      setLoading(false)
    }
  }, [orderId])

  useEffect(() => {
    fetchDetail()
  }, [fetchDetail])

  return { detail, loading, error, refresh: fetchDetail }
}
